import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LeftNavSidebar, AppLayout, Navbar, Flyout } from 'containers';
import { connect } from 'react-redux';
import * as styles from './LeftNavLayout.scss';
var LeftNavLayout = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    isLikeableUser: state.config.userType.isLikeableUser,
    likeablelocalAllowedWhitelabel: state.config.userType.likeablelocalAllowedWhitelabel,
    theme: state.theme,
    partnerSubtype: function () {
      try {
        return state.whiteLabel.Organization.OrganizationSubtype.subtype;
      } catch (e) {
        return null;
      }
    }()
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(LeftNavLayout, _Component);

  var _super = _createSuper(LeftNavLayout);

  function LeftNavLayout() {
    _classCallCheck(this, LeftNavLayout);

    return _super.apply(this, arguments);
  }

  _createClass(LeftNavLayout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appLayoutInnerStyle = _this$props.appLayoutInnerStyle,
          children = _this$props.children,
          sidebar = _this$props.sidebar,
          sidebarItems = _this$props.sidebarItems,
          wrapStyle = _this$props.wrapStyle,
          user = _this$props.user,
          partnerSubtype = _this$props.partnerSubtype;
      var isPartnerOwner = user && (user.isPartnerOwner || user.isLikeableLocal && user.likeablelocalAllowedWhitelabel);
      var leftNavItems = [];

      if (sidebar) {
        if (sidebar === 'admin' && !this.props.isLikeableUser) {
          leftNavItems = [{
            link: '/global/clients',
            linkText: partnerSubtype && partnerSubtype === 'multilocation' ? 'Locations' : 'Clients'
          }, {
            link: '/global/team',
            linkText: 'Team'
          }, {
            link: '/global/report-builder',
            linkText: 'Report Builder'
          }, {
            link: '/global/group-posts',
            linkText: 'Group Posts'
          }, {
            link: '/global/whitelabel',
            linkText: 'White Labeling'
          }, isPartnerOwner && {
            link: '/global/partner',
            linkText: 'Settings'
          }].filter(function (o) {
            return o;
          });
        } else if (sidebar === 'admin' && this.props.isLikeableUser) {
          var canAccessPartners = user && user.Roles && user.Roles.length && user.Roles.some(function (role) {
            return role.id === 1;
          });
          leftNavItems = [{
            link: '/global/clients',
            linkText: partnerSubtype && partnerSubtype === 'multilocation' ? 'Locations' : 'Clients'
          }, {
            link: '/global/group-posts',
            linkText: 'Group Posts'
          }, canAccessPartners && this.props.theme.org === 0 ? {
            link: '/global/dashboard',
            linkText: 'Dashboard'
          } : null, canAccessPartners && this.props.theme.org === 0 ? {
            link: '/global/partners',
            linkText: 'Partners'
          } : null, {
            link: '/global/team',
            linkText: 'Team'
          }, !this.props.likeablelocalAllowedWhitelabel ? {
            link: '/global/agreements',
            linkText: 'Agreements'
          } : null, {
            link: '/global/report-builder',
            linkText: 'Report Builder'
          }, {
            link: '/global/whitelabel',
            linkText: 'White Labeling'
          }, isPartnerOwner && {
            link: '/global/partner',
            linkText: 'Settings'
          }, canAccessPartners && this.props.theme.org === 0 ? {
            link: '/global/package-manager',
            linkText: 'Package Manager'
          } : null].filter(function (o) {
            return o;
          });
        } else if (sidebarItems) {
          leftNavItems = sidebarItems;
        }
      } // console.log('this.props.rightPanel');
      // console.log(this.props.rightPanel);


      return /*#__PURE__*/React.createElement(AppLayout, {
        appLayoutInnerStyle: appLayoutInnerStyle,
        params: _objectSpread({}, this.props.params),
        adminPage: sidebar === 'admin' || sidebar === 'billing'
      }, sidebar && /*#__PURE__*/React.createElement(LeftNavSidebar, {
        items: leftNavItems
      }), /*#__PURE__*/React.createElement("div", {
        style: wrapStyle
      }, children), /*#__PURE__*/React.createElement(Flyout, null, this.props.rightPanel));
    }
  }]);

  return LeftNavLayout;
}(Component), _defineProperty(_class2, "propTypes", {
  children: PropTypes.any.isRequired,
  sidebar: PropTypes.any,
  sidebarItems: PropTypes.array,
  user: PropTypes.object
}), _defineProperty(_class2, "defaultProps", {
  appLayoutInnerStyle: {
    display: 'flex',
    flex: '1 1 auto',
    padding: 0,
    overflow: 'hidden',
    overflowY: 'auto',
    height: '100%'
  },
  sidebar: null,
  sidebarItems: null,
  wrapStyle: {
    flex: '1 1 auto',
    padding: 36
  }
}), _temp)) || _class);
export default LeftNavLayout;